import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useAuth } from '@features/auth/hooks/useAuth';
import { useAchievementsListQuery } from '@features/shared/api/user';
import { PlayerAchievementsListPreview } from '@features/user/ui/PlayerAchievementsListPreview/PlayerAchievementsListPreview';

export function PlayerAchievementsListPreviewWidget() {
  const navigate = useNavigate();
  const onShowMore = useCallback(() => {
    navigate({
      from: '/',
      to: '/profile/achievements',
    });
  }, [navigate]);

  const { user } = useAuth();
  const { data } = useAchievementsListQuery({
    userId: user?.userId || '',
    enabled: !!user?.userId,
  });

  return <PlayerAchievementsListPreview achievements={data?.items} onShowMore={onShowMore} />;
}
